import React, { Component } from 'react';
import '../Styles/NumberPad.css';

export default class NumberPad extends Component {

  render(){
    var numbers = [1,2,3,4,5,6,7,8,9,0]
    const numberButtons = numbers.map((number) =>
      <button 
          onClick={() => this.props.add_char(number)} 
          className="number" 
          key={"pad" + number.toString()} 
      >
          {number}
      </button>
    );

    let prefLang = sessionStorage.getItem("preferredLanguage");
    let clearText = prefLang !== "ES" ? "Clear" : "Limpiar";

    return (
      <div 
        className="numberPad"
      >
        {numberButtons}
        <button 
          onClick={this.props.delete_char ? () => this.props.delete_char() : () => this.props.update_text('')} 
          className="delete"
        >
          {clearText}
        </button>
      </div>
    );
  }
}